import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_403: DocMigration = {
  maxSchemaVersion: "0.0.403",
  description:
    "Break out ANNOTATION category to ANNOT_DETAIL, ANNOT_NOTE, and ANNOT_LINEWORK on elevation view templates",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];

      if (viewTemplate.viewType === "ELEVATION_VIEW") {
        const annotationIndex = viewTemplate.categories?.findIndex((category) => category === "ANNOTATION");
        if (annotationIndex >= 0) {
          viewTemplate.categories.splice(annotationIndex, 1);
          if (!viewTemplate.categories.includes("ANNOT_DETAIL")) {
            viewTemplate.categories.push("ANNOT_DETAIL");
          }
          if (!viewTemplate.categories.includes("ANNOT_NOTE")) {
            viewTemplate.categories.push("ANNOT_NOTE");
          }
          if (!viewTemplate.categories.includes("ANNOT_LINEWORK")) {
            viewTemplate.categories.push("ANNOT_LINEWORK");
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_403;
